import { useState } from "react";
import { toast } from "sonner";
import { Star } from "lucide-react";
import { api, errorMessage } from "@/lib/adminApi";
import { FIELD } from "@/components/admin/AdminLogin";

const EMPTY = { author: "", rating: 5, text: "", review_date: "" };

export default function AddReview({ onAdded }) {
    const [form, setForm] = useState(EMPTY);
    const [busy, setBusy] = useState(false);
    const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await api.post("/admin/testimonials", { ...form, review_date: form.review_date || null });
            toast.success("Review added to pending");
            setForm(EMPTY);
            onAdded();
        } catch (err) {
            toast.error(errorMessage(err));
        } finally {
            setBusy(false);
        }
    };

    return (
        <form onSubmit={submit} className="rounded-2xl border border-border bg-surface p-6" data-testid="add-review-form">
            <h2 className="font-display text-lg font-bold">Paste a single review</h2>
            <p className="mt-1 text-xs text-muted-foreground">Copy the reviewer name and text straight from Google. It lands in Pending for approval.</p>
            <div className="mt-5 space-y-3">
                <input required placeholder="Reviewer name" value={form.author} onChange={set("author")} className={FIELD} data-testid="add-review-author" />
                <div className="flex items-center gap-3">
                    <span className="text-xs text-muted-foreground">Rating</span>
                    <div className="flex gap-1" data-testid="add-review-rating">
                        {[1, 2, 3, 4, 5].map((i) => (
                            <button type="button" key={i} onClick={() => setForm((f) => ({ ...f, rating: i }))} aria-label={`${i} stars`} data-testid={`add-review-star-${i}`}>
                                <Star size={20} className={i <= form.rating ? "fill-primary text-primary" : "text-border"} />
                            </button>
                        ))}
                    </div>
                    <input type="date" value={form.review_date} onChange={set("review_date")} className={`${FIELD} ml-auto w-auto`} data-testid="add-review-date" />
                </div>
                <textarea required rows={5} placeholder="Review text" value={form.text} onChange={set("text")} className={`${FIELD} resize-y`} data-testid="add-review-text" />
            </div>
            <button type="submit" disabled={busy} data-testid="add-review-submit" className="mt-5 rounded-full bg-primary px-6 py-2.5 text-sm font-bold text-primary-foreground transition-transform duration-200 hover:scale-[1.03] active:scale-95 disabled:opacity-50">
                {busy ? "Adding…" : "Add to pending"}
            </button>
        </form>
    );
}
